/* eslint-disable no-mixed-operators */
import { HALF_HOUR_IN_DAYS, isCookieSet, setCookie } from 'helpers/cookies-helper';
import React, { Component } from 'react';
import SuggestionBox, { ADVERTISERS, SUGGESTION_BOX_ACTIONS } from 'molecules/suggestion-box';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { COOKIES } from 'constants/constants';
import { defaultWeekend } from 'helpers/dates-helper';
import { getPageType } from 'services/tracking/gtm/gtm-data';
import { gtmMicroconversions } from 'services/tracking/gtm/gtm-events';
import { logSuggestionbox } from 'services/tracking/logger';
import { PAGES } from 'constants/routes';
import PropTypes from 'prop-types';
import { requestSuggestionBox } from 'actions/adActions';
import { translatable } from 'services/Intl';


class SuggestionBoxContainer extends Component {
  constructor(props) {
    super(props);
    this.location = getPageType(window.location);
    this.destinationName = null;
    this.didScroll = false;
    this.isDesktop = !(global.isPhone || global.isTablet);
    this.showSuggestion = (this.location === PAGES.BLOG_POST || this.location === PAGES.SEO_LANDING_PAGE_1);
    this.areImpressionTracked = false;
    this.state = {
      classNames: ['-suggestion-box-hidden'],
      mustBeDot: false,
      mustCloseForever: false,
    };
  }

  componentDidMount() {
    const { destination, underComponent } = this.props;
    [this.destinationName] = destination.name.split(',');
    window.addEventListener('scroll', this.handleScroll.bind(this));
    this.appearingLogic(underComponent);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll.bind(this));
    clearInterval(this.intervalId);
  }

  handleScroll() {
    this.didScroll = true;
  }

  handleOnClickSuggestion(type, e) {
    e.stopPropagation();
    const { ad, destination: { name }, searchFormState: { guestsNumber, dateArrival, dateLeaving } } = this.props;
    const [defaultDateArrival, defaultDateLeaving] = defaultWeekend('YYYY-MM-DD');
    switch (type) {
      case SUGGESTION_BOX_ACTIONS.OPEN:
        gtmMicroconversions('sb-click', `${ad.name}/${name || 'n-a'}/${guestsNumber}/${dateArrival || defaultDateArrival}_${dateLeaving || defaultDateLeaving}`);
        logSuggestionbox(ad);
        return this.openAd();
      case SUGGESTION_BOX_ACTIONS.CLOSE:
        return this.closeLogic();
      default:
        break;
    }
  }

  openAd() {
    const { ad, searchFormState, destination, requestSuggestionBoxAction } = this.props;
    if (!this.isDesktop) this.setState({ mustCloseForever: true });
    else this.setState({ classNames: ['-close-no-hover'], mustBeDot: true });
    window.open(ad.clickout, '_blank');
    requestSuggestionBoxAction(Object.assign({}, searchFormState, destination));
    if (!this.isDesktop) setCookie(COOKIES.SUGGESTION_BOX, HALF_HOUR_IN_DAYS);
  }

  closeLogic() {
    if (this.location === PAGES.SEO_LANDING_PAGE_1 || (this.location === PAGES.BLOG_POST && !this.isDesktop)) {
      this.setState({ mustCloseForever: true });
    } else {
      this.setState({ mustBeDot: true });
      this.setState({ classNames: ['-close-no-hover'] });
    }
    setCookie(COOKIES.SUGGESTION_BOX, HALF_HOUR_IN_DAYS);
  }

  trackImpression() {
    const { ad, destination: { name }, searchFormState: { guestsNumber, dateArrival, dateLeaving } } = this.props;
    const [defaultDateArrival, defaultDateLeaving] = defaultWeekend('YYYY-MM-DD');
    gtmMicroconversions('sb-impression', `${ad.name}/${name || 'n-a'}/${guestsNumber}/${dateArrival || defaultDateArrival}_${dateLeaving || defaultDateLeaving}`);
    this.areImpressionTracked = true;
  }

  appearingLogic(component) {
    let openUnderThis = document.querySelector(`.${component}`);
    let componentDisapear = openUnderThis ? openUnderThis.offsetTop + openUnderThis.offsetHeight : null;
    if (isCookieSet(COOKIES.SUGGESTION_BOX) && this.location === PAGES.BLOG_POST) this.setState({ mustBeDot: true });

    if (!this.state.mustBeDot) { // eslint-disable-line
      this.interval = setInterval(() => {
        const { classNames } = this.state;
        if (!openUnderThis) {
          openUnderThis = document.querySelector(`.${component}`);
          componentDisapear = openUnderThis ? openUnderThis.offsetTop + openUnderThis.offsetHeight : null;
        }
        if (this.didScroll && !this.state.mustBeDot) { // eslint-disable-line
          this.didScroll = false;
          if (window.scrollY > componentDisapear) {
            if (this.isDesktop) this.setState({ classNames: ['-open'] });
            else this.setState({ classNames: ['-suggestion-box-growing'] });
          } else {
            const index = classNames.indexOf('-open');
            if (index > -1) classNames.splice(classNames.indexOf('-open'), 1);
            if (!classNames.includes('-close')) classNames.push('-close');
            this.setState({ classNames });
          }
        }
        if (this.state.mustBeDot && !classNames.includes('-close')) { // eslint-disable-line
          setTimeout(() => this.setState({ classNames: ['-close'] }), 500);
        }
      }, 500);
    }
  }

  render() {
    const { ad, t } = this.props;
    const { classNames, mustCloseForever } = this.state;

    if (!(this.showSuggestion && ad && !mustCloseForever
      && (!isCookieSet(COOKIES.SUGGESTION_BOX) || isCookieSet(COOKIES.SUGGESTION_BOX)
      && this.isDesktop && this.location === PAGES.BLOG_POST))) return null;

    if (!this.areImpressionTracked && !classNames.includes('-suggestion-box-hidden')) this.trackImpression();

    return (
      <SuggestionBox
        adLogo={ `https://static.100r.systems/img/inline-ads/${ad.name}_logo.png` }
        advertiser={ ADVERTISERS[ad.name] }
        className={ `blog-home__suggestion-box ${classNames.join(' ')}` }
        handleOnClick={ this.handleOnClickSuggestion.bind(this) }
        t={ t }
        text={ this.destinationName ? t('Feel right at home in {destination}', { destination: this.destinationName }) : t('Feel right at home during your trip') }
      />
    );
  }
}

SuggestionBoxContainer.defaultProps = {
  ad: null,
  underComponent: '',
};

SuggestionBoxContainer.propTypes = {
  ad: PropTypes.shape({
    clickout: PropTypes.string,
    transactionId: PropTypes.string,
  }),
  destination: PropTypes.shape().isRequired,
  requestSuggestionBoxAction: PropTypes.func.isRequired,
  searchFormState: PropTypes.shape().isRequired,
  t: PropTypes.func.isRequired,
  underComponent: PropTypes.string,
};

const mapStateToProps = state => ({
  ad: state.adsReducer.suggestionBox,
  destination: state.destination,
  searchFormState: state.searchFormReducer,
});

const mapDispatchToProps = dispatch => bindActionCreators({ requestSuggestionBoxAction: requestSuggestionBox }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(translatable(SuggestionBoxContainer));
